const GridJs = [
	{
		id: '01',
		name: 'Jonathan',
		email: 'jonathan@example.com',
		position: 'Senior Implementation Architect',
		company: 'Hauck Inc',
		country: 'Holy See',
	},
	{
		id: '02',
		name: 'Harold',
		email: 'harold@example.com',
		position: 'Forward Creative Coordinator',
		company: 'Metz Inc',
		country: 'Iran',
	},
	{
		id: '03',
		name: 'Shannon',
		email: 'shannon@example.com',
		position: 'Legacy Functionality Associate',
		company: 'Zemlak Group',
		country: 'South Georgia',
	},
	{
		id: '04',
		name: 'Robert',
		email: 'robert@example.com',
		position: 'Product Accounts Technician',
		company: 'Hoeger',
		country: 'San Marino',
	},
	{
		id: '05',
		name: 'Noel',
		email: 'noel@example.com',
		position: 'Customer Data Director',
		company: 'Howell - Rippin',
		country: 'Germany',
	},
	{
		id: '06',
		name: 'Traci',
		email: 'traci@example.com',
		position: 'Corporate Identity Director',
		company: 'Koelpin - Goldner',
		country: 'Vanuatu',
	},
	{
		id: '07',
		name: 'Kerry',
		email: 'kerry@example.com',
		position: 'Lead Applications Associate',
		company: 'Feeney, Langworth and Tremblay',
		country: 'Niger',
	},
	{
		id: '08',
		name: 'Patsy',
		email: 'patsy@example.com',
		position: 'Dynamic Assurance Director',
		company: 'Streich Group',
		country: 'Niue',
	},
	{
		id: '09',
		name: 'Cathy',
		email: 'cathy@example.com',
		position: 'Customer Data Director',
		company: 'Ebert, Schamberger and Johnston',
		country: 'Mexico',
	},
	{
		id: '10',
		name: 'Tyrone',
		email: 'tyrone@example.com',
		position: 'Senior Response Liaison',
		company: 'Raynor, Rolfson and Daugherty',
		country: 'Qatar',
	},
];

export { GridJs };
